/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';

import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FlagBasedPreloadingStrategy extends PreloadingStrategy {
  // 👇 For clarity, I prefer `load` rather than `fn` for the callback name
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Don't preload if explicitly set to false
    if (route.data?.['preload'] === false) {
      return of(null);
    }

    // Network-aware preloading - check connection type
    if (typeof navigator !== 'undefined' && 'connection' in navigator) {
      const conn = (navigator as any).connection;
      // Don't preload on slow connections
      if (conn && (conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g')) {
        return of(null);
      }
    }

    // Delay preloading to not interfere with initial load
    // Only preload if explicitly marked or after a delay
    const delay = route.data?.['preload'] === true ? 0 : 2000;

    return timer(delay).pipe(mergeMap(() => load()));
  }
}
